import { ActionReducer, Action } from '@ngrx/store';
import { CopyDataInitState } from '../models/copy.interface';

export const UPDATE_COPY = 'UPDATE_COPY';
export const REFRESH_COPY = 'REFRESH_COPY';
export const RESET_COPY = 'RESET_COPY';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: CopyDataInitState = {
  copyLoaded: false,
  carrierKey: {},
  airlines: [
    {carrier: '', pages: []}
  ],
  language: '',
  languageCode: 'en'
};

export function copyReducer (state: CopyDataInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {
    case UPDATE_COPY:
      return Object.assign({}, action.payload);

    case REFRESH_COPY:
      return Object.assign({}, action.payload);

    case RESET_COPY:
      return Object.assign({}, initState);

    case UPDATE_LANGUAGE:
      return Object.assign({}, state, action.payload )
    default:
      return state;

  }
};
